<script lang="ts" setup>
import BrowserSuggest from '../BrowserSuggest.vue';
import Header from './Header.vue';
import Footer from './Footer.vue';
import JncyNavbar from '../jncy-layout/Navbar.vue';
import JncyFooter from '../jncy-layout/Footer.vue';
import { useRoute } from 'vue-router';
import { computed } from 'vue';
import { useJncyLayout } from '@/composables/useJncyLayout';
import { useLayout } from '@/composables/useLayout';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import { isInAppEnvironment } from '@/pages/course/composables/coursePlay/utils';

const route = useRoute();
const { showJncyLayout } = useJncyLayout();
const { layheader } = useLayout();
const isAi = computed(() => {
  // 检查当前页面是否为 AI 助手页面
  return (
    window.location.pathname.includes('AIAssistant.html') ||
    route.path.includes('AIAssistant') ||
    window.location.href.includes('AIAssistant.html')
  );
});

// 判断是否在 app 环境
const isInApp = computed(() => isInAppEnvironment());

const minheight = computed(() => {
  // 在 app 环境下，不显示头部和尾部，使用全屏高度
  if (isInApp.value) {
    return '100vh';
  }
  // 技能大师布局用自身 container 高度，不套普通页 minHeight
  if (showJncyLayout.value) {
    return undefined;
  }
  const headerheight = layheader.value ? layheader.value.clientHeight : 0;
  if (headerheight) {
    return `calc(100vh - ${headerheight}px - 260px)`;
  }
  return `calc(100vh - 80px - 260px)`;
});
</script>
<template>
  <el-config-provider :locale="zhCn">
    <div :class="{ 'jncy-layout-root': showJncyLayout }">
      <BrowserSuggest />

      <!-- 仅切换头尾，RouterView 保持单一实例，避免 type===1 切布局时页面重挂载导致接口翻倍 -->
      <JncyNavbar v-if="showJncyLayout && !isInApp" />
      <Header v-else-if="!isAi && !isInApp" />

      <div
        :class="showJncyLayout ? 'jncy-layout-container' : 'layout-content'"
        :style="minheight ? { minHeight: minheight } : undefined"
      >
        <RouterView />
      </div>

      <JncyFooter v-if="showJncyLayout && !isInApp" />
      <Footer v-else-if="!isAi && !isInApp" />
    </div>
  </el-config-provider>
</template>

<style lang="scss" scoped>
.jncy-layout-root {
  position: relative;
}
.jncy-layout-container {
  min-height: calc(100vh - 212px);
}
</style>
